import React from "react";
import { useLocation } from "wouter";
import { Typography } from "@mui/material";

import logo from "../../assets/nwt.png";
import Button, { ButtonTypes } from "../../components/Button";
import { StatusBadge } from "../../components/Badge";
import {
  BrandIcon,
  BrandSection,
  Card,
  CardSection,
  Container,
  ContentWrapper,
} from "./styles";

const getStatusMessages = (status: "success" | "error" | "expired") => {
  switch (status) {
    case "success":
      return {
        title: "Account Verified!",
        message:
          "Your account has been successfully verified. You can now log in.",
        className: "success",
      };
    case "expired":
      return {
        title: "Verification Link Expired",
        message:
          "The verification link has expired. Please contact support to request a new one.",
        className: "expired",
      };
    case "error":
    default:
      return {
        title: "Verification Failed",
        message:
          "There was an error verifying your account. Please try again or contact support.",
        className: "error",
      };
  }
};

const getStatusBadge = (className: string, title: string) => {
  if (className === "expired") {
    return (
      <StatusBadge
        key="inactive"
        keyId="inactive"
        className="inactive"
        text={title}
        icon={"⚠️"}
      />
    );
  }
  if (className === "success") {
    return (
      <StatusBadge
        key="active"
        keyId="active"
        className="active"
        text={title}
        icon={"✅"}
      />
    );
  }

  return (
    <StatusBadge
      key="inactive"
      keyId="inactive"
      className="inactive"
      text={title}
      icon={"❌"}
    />
  );
};

export const VerifyPage: React.FC = () => {
  const [, navigate] = useLocation();

  // Get status from query string
  const searchParams = new URLSearchParams(globalThis.window.location.search);
  const status = (searchParams.get("status") ?? "error") as
    "success" | "error" | "expired";

  const { title, message, className } = getStatusMessages(status);

  return (
    <Container>
      <ContentWrapper>
        <CardSection>
          <Card elevation={0}>
            <BrandSection>
              <BrandIcon>
                <img src={logo} alt="NWT" />
              </BrandIcon>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", color: "var(--color-primary)" }}
                gutterBottom
              >
                Net Worth Tracker
              </Typography>
            </BrandSection>

            <div style={{ textAlign: "center" }}>
              {getStatusBadge(className, title)}
              <p style={{ margin: "1.5rem 0rem", fontSize: "var(--text-lg)" }}>
                {message}
              </p>
              <Button
                onClick={() => navigate("/")}
                type={ButtonTypes.primary}
                size="large"
                isFullWidth={true}
              >
                Go to Login
              </Button>
            </div>
          </Card>
        </CardSection>
      </ContentWrapper>
    </Container>
  );
};
